<div class='modal-dialog' role='document'>
  <div class='modal-content p-2'>
    <div class='modal-header py-3 d-flex align-items-center'>
      <h5 class='modal-title mb-0' id='modalTitle'>Email</h5>
      <button type='button' class='close' data-dismiss='modal' aria-label='Close'>
        <span aria-hidden='true'>&times;</span>
      </button>
    </div>
    <div class='text-danger ml-3 mt-2 mb-0' *ngIf='submitted && !email.to[0]'>
      Please enter a recipient email.
    </div>
    <div class='modal-header justify-content-start align-items-center' (click)='focusEmailInput()'>
      <span class='mr-2 font-16'>To: </span>
      <span class='alert alert-info p-1 m-0 mr-2 email-list d-flex align-items-center'
            *ngFor='let email of this.email?.to'>{{email}}
        <button type='button' class='close' aria-label='Close' id='closeButton' [value]='email'
                (click)='removeReceivingAddress(email)'>
            <span aria-hidden='true'>&times;</span>
          </button>

        </span>

      <input id='emailInput' (keyup.enter)='addReceivingAddress($event)' (blur)='addReceivingAddress($event)'>

    </div>

    <div class='modal-header justify-content-start align-items-center font-16'>
      <span class='mr-2'>Subject: </span>
      {{this.email?.subject}}
    </div>
    <div class='modal-header justify-content-start align-items-center font-16'>
      <span class='mr-2'>From: </span>
      {{this.email?.from}}
    </div>
    <div class='modal-body' [innerHTML]='this.email?.html'>
    </div>
    <div class='d-flex justify-content-center w-100 px-3'>
      <div class='alert alert-light d-flex align-items-center'>

        <img class='mr-2' src='../../assets/pdf-icon.png' height='27' width='20'/>
        <strong *ngIf='selectedItem'><span class='text-capitalize'>{{selectedItem?.calculationResult?.testType}}</span> Result.pdf</strong>
        <strong *ngIf='location'><span class='text-capitalize'>{{location?.name}}</span>.pdf</strong>
      </div>
    </div>
    <div class='modal-footer'>
      <button type='button' class='btn btn-secondary cancel-email' data-dismiss='modal'>Cancel</button>
      <button type='button' class='btn btn-primary send-email' [hidden]='!email?.to[0]' data-dismiss='modal'
              (click)='sendEmail()'>Send
      </button>

      <button type='button' class='btn btn-primary send-email' [hidden]='email?.to[0]' (click)='sendEmail()'>Send
      </button>
    </div>
  </div>
</div>
